import 'Plugins/slickCarouselPlugin';

// slick init
export default function initSlickCarousel() {
	jQuery('.footer-slider').slick({
		slidesToScroll: 1,
		slidesToShow: 5,
		rows: 0,
		prevArrow: '<button class="slick-prev">Previous</button>',
		nextArrow: '<button class="slick-next">Next</button>',
		arrows: false,
		autoplay: true,
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
			}
		}, {
			breakpoint: 520,
			settings: {
				slidesToShow: 1,
			}
		}]
	});

	jQuery('.image-gallery').slick({
		centerMode: true,
		centerPadding: '0px',
		slidesToShow: 1,
		rows: 0,
		prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.8 11.2"><g><path d="M6.8,10.8L0.8,5.6l6.1-5.2"/><line x1="0.8" y1="5.6" x2="44.8" y2="5.6"/></g></svg></button>',
		nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.8 11.2"><g><path d="M37.9,0.4L44,5.6l-6.1,5.2"/><line x1="44" y1="5.6" x2="0" y2="5.6"/></g></svg></button>',
		dots: true,
		dotsClass: 'slick-dots'
	});

	jQuery('.carousel-block').each(function() {
		var holder = jQuery(this);
		var sliderHolder = holder.find('.slider-holder');
		var switcherItems = holder.find('.slider-list a');
		var slider = sliderHolder.find('.text-slider');
		var arrowHolder = sliderHolder.find('.arrow-holder');
		var activeClass = 'active';
		var allParents = jQuery();

		slider.slick({
			slidesToScroll: 1,
			slidesToShow: 1,
			rows: 0,
			prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.8 11.2"><g><path d="M6.8,10.8L0.8,5.6l6.1-5.2"/><line x1="0.8" y1="5.6" x2="44.8" y2="5.6"/></g></svg></button>',
			nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.8 11.2"><g><path d="M37.9,0.4L44,5.6l-6.1,5.2"/><line x1="44" y1="5.6" x2="0" y2="5.6"/></g></svg></button>',
			arrows: true,
			appendArrows: arrowHolder,
			fade: true,
			responsive: [{
				breakpoint: 768,
				settings: {
					arrows:true,
				}
			}]
		});

		switcherItems.each(function(i) {
			var item = jQuery(this);
			var parent = item.closest('li');

			allParents = allParents.add(parent);

			if (i === 0) {
				parent.addClass(activeClass);
			}

			item.on('click', function(e) {
				e.preventDefault();

				slider.slick('slickGoTo', i);
				allParents.removeClass(activeClass);
				parent.addClass(activeClass);
			});
		});

		slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			allParents.removeClass(activeClass);
			allParents.eq(nextSlide).addClass(activeClass);
		});
	});

	jQuery('.info-slider').slick({
		slidesToShow: 1,
		rows: 0,
		dots: true,
		dotsClass: 'slick-dots',
		arrows: false
	});

	jQuery('.floorplan-section').each(function() {
		var holder = jQuery(this);
		var sliderHolder = holder.find('.floorplans-slider-holder');
		var slider = sliderHolder.find('.popup-slider');
		var arrowHolder = sliderHolder.find('.arrow-holder');
		var switcherItems = holder.find('.slider-list a');
		var allParents = jQuery();
		var activeClass = 'active';

		ResponsiveHelper.addRange({
			'..767': {
				on: function() {
					destroySlider();
				}
			},
			'768..': {
				on: function() {
					initSlider();
				}
			}
		});

		switcherItems.each(function(i) {
			var item = jQuery(this);
			var parent = item.closest('li');

			allParents = allParents.add(parent);

			if (i === 0) {
				parent.addClass(activeClass);
			}

			function itemClickHandler(e) {
				e.preventDefault();

				slider.slick('slickGoTo', i);
				allParents.removeClass(activeClass);
				parent.addClass(activeClass);
			}

			ResponsiveHelper.addRange({
				'..767': {
					on: function() {
						item.off('click', itemClickHandler);
					}
				},
				'768..': {
					on: function() {
						item.on('click', itemClickHandler);
					}
				}
			});
		});

		function initSlider() {
			slider.slick({
				slidesToScroll: 1,
				slidesToShow: 1,
				rows: 0,
				prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.8 11.2"><g><path d="M6.8,10.8L0.8,5.6l6.1-5.2"/><line x1="0.8" y1="5.6" x2="44.8" y2="5.6"/></g></svg></button>',
				nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.8 11.2"><g><path d="M37.9,0.4L44,5.6l-6.1,5.2"/><line x1="44" y1="5.6" x2="0" y2="5.6"/></g></svg></button>',
				arrows: true,
				appendArrows: arrowHolder,
				responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
					}
				}]
			});

			slider.on('beforeChange.slider', function(event, slick, currentSlide, nextSlide){
				allParents.removeClass(activeClass);
				allParents.eq(nextSlide).addClass(activeClass);
			});
		}

		function destroySlider() {
			if (slider.hasClass('slick-initialized')) {
				slider.off('beforeChange.slider');
				slider.slick('unslick');
			}
		}
	});

	jQuery('.video-slider').each(function() {
		var slider = jQuery(this);
		var slides = slider.find('.slide');

		slider.slick({
			centerMode: true,
			centerPadding: '0px',
			slidesToShow: 1,
			rows: 0,
			prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.8 11.2"><g><path d="M6.8,10.8L0.8,5.6l6.1-5.2"/><line x1="0.8" y1="5.6" x2="44.8" y2="5.6"/></g></svg></button>',
			nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.8 11.2"><g><path d="M37.9,0.4L44,5.6l-6.1,5.2"/><line x1="44" y1="5.6" x2="0" y2="5.6"/></g></svg></button>',
			dots: true,
			dotsClass: 'slick-dots',
			asNavFor: '.video-description-slider',
		});

		if (slider.slick('slickGetOption', 'autoplay')) {
			slider.find('[data-video]').each(function() {
				var holder = jQuery(this);

				holder.on('playingVideo', function() {
					slider.slick('slickPause');
				}).on('pauseVideo', function() {
					slider.slick('slickPlay');
				}).on('endedVideo', function() {
					slider.slick('slickPlay');
				});
			});
		}

		slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			var currVideoBlock = slides.eq(currentSlide).find('[data-video]');

			if (currVideoBlock.length && currVideoBlock.data('BgVideo').player) {
				currVideoBlock.data('BgVideo').player.pause();
			}
		});
	});

	jQuery('.video-description-slider').slick({
		slidesToShow: 1,
		rows: 0,
		dots: false,
		arrows: false,
		fade: true,
		adaptiveHeight: true,
		asNavFor: '.video-slider',
		draggable: false,
		pauseOnHover: false,
		swipe: false,
		touchMove: false,
	});
}